import React, { useState } from "react"
import { ArrowBackRounded, ArrowForwardRounded } from "@mui/icons-material"
import { Grid, IconButton, Skeleton, Typography } from "@mui/material"

const LIMIT = 6

interface Props {
  browserTitle: string,
  noDataMessage: string,
  children: React.ReactNode,
  totalCount: number,
  onPageChange: (activePage: number) => void
}

const Browser: React.FC<Props> = ({ browserTitle, noDataMessage, totalCount, onPageChange, children }: Props) => {
  const [activePage, setActivePage] = useState<number>(0)

  const childrenCount = React.Children.count(children)

  const hidePrev = activePage == 0
  const hideNext = activePage * LIMIT + childrenCount >= totalCount

  const pageChanged = (newPage: number) => {
    setActivePage(newPage)
    onPageChange(newPage)
  }

  const renderBrowser = () => {
    return (<> {children} </>)
  }

  const renderSkeleton = () => {
    return (<> {Array.from(Array(6).keys()).map((i) => <Skeleton key={i} className="card-frame" />)} </>)
  }

  const noData = () => {
    return <Typography variant="body1" sx={{ paddingBottom: '100px' }}>{noDataMessage}</Typography>
  }
  const prevVisibility = hidePrev ? 'hidden' : 'visible'
  const nextVisibility = hideNext ? 'hidden' : 'visible'
  return (
    <Grid container alignItems="center" sx={{ px: { md: 2 } }}>
      <Grid item xs={'auto'}>
        <IconButton sx={{ visibility: prevVisibility, background: '#F1F1F1' }} onClick={() => { pageChanged(activePage - 1) }}>
          <ArrowBackRounded fontSize="large" />
        </IconButton>
      </Grid>
      <Grid item xs >
        <Typography variant="h5">{browserTitle}</Typography>
        <Grid container>
          {(!children) ? renderSkeleton() : childrenCount > 0 ? renderBrowser() : noData()}
        </Grid>
      </Grid>
      <Grid item xs={'auto'}>
        <IconButton sx={{ visibility: nextVisibility, background: '#F1F1F1' }} onClick={() => { pageChanged(activePage + 1) }}>
          <ArrowForwardRounded fontSize="large" />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default Browser